import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { DEPARTMENTS_FEATURE_KEY } from './keys';
import { departmentsReducer } from './reducers/departments.reducer';
import { DepartmentsEffects } from './effects/departments.effects';
import { DepartmentsDepartmentBridge } from './bridges/departments_department.bridge';

export function provideDepartmentsStore(): EnvironmentProviders[] {
    return [provideState(DEPARTMENTS_FEATURE_KEY, departmentsReducer), provideEffects(DepartmentsEffects, DepartmentsDepartmentBridge)];
}
